import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { EBuildingGatesType } from '../../../../api-models/common/json_query';

const ID = 'buildingGatesType' as const;

const GATES_MAP_VALUE_TO_LABEL: Record<EBuildingGatesType, string> = {
  [EBuildingGatesType.Dock]: 'Ворота докового типа',
  [EBuildingGatesType.Ground]: 'Ворота на нулевой отметке',
  [EBuildingGatesType.Ramp]: 'Ворота на пандусе',
};

export const buildingGatesTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const types = getTermsValue('building_gates_type')(jsonQuery);

    if (types === null) {
      return null;
    }

    return types.map(t => ({
      label: GATES_MAP_VALUE_TO_LABEL[t],
      value: createTagValue(ID, t.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const types = getTermsValue('building_gates_type')(jsonQuery);

    if (types === null) {
      return jsonQuery;
    }

    const next = types.filter(t => String(t) !== removingTagValue);

    return next.length > 0
      ? setTerms('building_gates_type')(jsonQuery)(next)
      : resetTerms(['building_gates_type'])(jsonQuery);
  },
};
